module.exports = __webpack_public_path__ + "static/media/variacao.76edd15f.png";